import { createContext } from "react";

// set the defaults
const UserContext = createContext({ user: null });

export default UserContext;